import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MainService } from '../main/main.service';
import { OFP_USUARIO } from '../../models/nomina-conade.model';


@Injectable({
  providedIn: 'root'
})
export class UsuariosService extends MainService {
  constructor(public http: HttpClient) {
    super(http);
  }

  consultar(filtro: string) {
    return this.getAsync(this.gatewayOficialiaPartesURL + 'Usuarios/OFP_USUARIOS_/Consultar' + filtro);
  }
  agregar(objeto: OFP_USUARIO) {
    return this.postAsync(this.gatewayOficialiaPartesURL + 'Usuarios/OFP_USUARIOS_/Agregar', objeto);
  }

  modificar(objeto: OFP_USUARIO) {
    return this.putAsync(this.gatewayOficialiaPartesURL + 'Usuarios/OFP_USUARIOS_/Editar', objeto);
  }

  eliminar(filtro: string) {
    return this.deleteAsync(this.gatewayOficialiaPartesURL + 'Usuarios/OFP_USUARIOS_/Eliminar'+ filtro);
  }

}
